export const createBoundProxy = <P extends object>(targetObject: P): P => {
  return new Proxy<P>(targetObject, {
    get<K extends keyof P>(target: P, prop: any, receiver: P): P[K] | Function {
      const value = Reflect.get(target, prop, receiver);

      if (typeof value === 'function') {
        return (value as Function).bind(target);
      }

      return value;
    },
  });
};
